import { render, staticRenderFns } from "./createSubFamily.vue?vue&type=template&id=b7ca2920&scoped=true"
import script from "./createSubFamily.vue?vue&type=script&lang=js"
export * from "./createSubFamily.vue?vue&type=script&lang=js"
import style0 from "./createSubFamily.vue?vue&type=style&index=0&id=b7ca2920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ca2920",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/createSubFamily.vue
// module id = 2134
// module chunks = 31